import React from "react";
import Kendra from "aws-sdk/clients/kendra";

import { Relevance } from "../../constants";
import blueThumbsUp from "../../images/blue-thumb-up.svg";
import blueThumbsDown from "../../images/blue-thumb-down.svg";
import whiteThumbsUp from "../../images/white-thumb-up.svg";
import whiteThumbsDown from "../../images/white-thumb-down.svg";
import singleRight from "../../images/arrow.png";
import "../../search.scss";

interface FeedbackProps {
  queryResultItem: Kendra.QueryResultItem;
  submitFeedback: (
    relevance: Relevance,
    resultItem: Kendra.QueryResultItem
  ) => Promise<void>;
}

interface FeedbackState {
  relevance?: Relevance;
}

export default class Feedback extends React.Component<
  FeedbackProps,
  FeedbackState
> {
  constructor(props: FeedbackProps) {
    super(props);

    this.state = {
      relevance: undefined
    };
  }

  private setRelevance(relevance: Relevance) {
    this.setState({ ...this.state, relevance });
  }

  private submitFeedback = (relevance: Relevance) => () => {
    this.setRelevance(relevance);
    this.props.submitFeedback(relevance, this.props.queryResultItem);
  };

  render() {
    const { relevance } = this.state;
var url='?searchTxt='+this.props.queryResultItem.DocumentTitle?.Text
    return (
      <span className="feedback-buttons">
         <a href={url} title="This is exacty meets my symptom.So I will accept this and want to add additional information"><img src={singleRight} style={{height:"35px",width:'50px',marginTop:'9px'}} /></a>
        <img
          alt="relevant"
          src={relevance === Relevance.Relevant ? blueThumbsUp : whiteThumbsUp}
          style={{height:'50px',width:'50px'}}
          onMouseOver={event => {
            event.currentTarget.src = blueThumbsUp;
          }}
          onMouseOut={event => {
            if (relevance !== Relevance.Relevant) {
              event.currentTarget.src = whiteThumbsUp;
            }
          }}
          onClick={this.submitFeedback(Relevance.Relevant)}
          title="Is this helpful?"
        />
        <img
          alt="not relevant"
          src={
            relevance === Relevance.NotRelevant
              ? blueThumbsDown
              : whiteThumbsDown
          }
          style={{height:'50px',width:'50px'}}
          onMouseOver={event => {
            event.currentTarget.src = blueThumbsDown;
          }}
          onMouseOut={event => {
            if (relevance !== Relevance.NotRelevant) {
              event.currentTarget.src = whiteThumbsDown;
            }
          }}
          onClick={this.submitFeedback(Relevance.NotRelevant)}
          title="Is this not helpful?"
        />
      </span>
    );
  }
}
